import {useState, useEffect} from "react";
import intersectionObserverHandler from '../../containers/common/intersection_observer';
/* global photoOrg,$ */
const useScrollRef = (albumClustersData,captionSort) => {
    const [ref,setRef] = useState(null);
  
    useEffect(()=>{
        photoOrg.rdropDownMenuButtonObj = photoOrg.Util.createMenuButtonObject('.libsettingsic a.newdropdown');
        if(captionSort){
            return;
        }
        intersectionObserverHandler.initialize();
        intersectionObserverHandler.observe();
    },[albumClustersData]);

    useEffect(()=>{
        try{
            //TODO: refactor the below usage
            if(!photoOrg.isRenderedProjectsTrayViewFromReact){
                photoOrg.isRenderedProjectsTrayViewFromReact=true;
                photoOrg.projectTrayView && photoOrg.projectTrayView.render();
            }
            photoOrg.Util.captureOnLoadPaintMetrics();
            //after all the response got appened scroll to it.
            //cliping is stopped due to performance issues as stated and not honoured in production as of now.
            if (ref && ref.current/* && location.hash === id*/) {
                ref.current.scrollIntoView({behavior: 'smooth'})
            }
        }catch(e){}
    },[])

    return [ref,setRef];
}

export default useScrollRef;
